var heading_default = {
  "fontElementMap": "vclBt",
  "elementSpacing": "nDvuG",
  "headerOne": "_8GR-H nDvuG",
  "headerTwo": "ZRV6T nDvuG",
  "headerThree": "-kAx6 nDvuG",
  "headerFour": "k139S nDvuG",
  "headerFive": "PXhGN nDvuG",
  "headerSix": "_8n27X nDvuG",
  "child": "Ifqz-"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
